// Tag: /tags//shared/googleTagManager/gtm_002dand_002ddatalayer.tag -->
window.tempDataLayer = {
  page: {},
  ecommerce: {},
  checkout: {},
  botTraffic: {},
};

if (typeof dataLayer === "undefined") {
  var dataLayer = [];
}

function updateTempLayer(data) {
  const temp = window.tempDataLayer;
  window.tempDataLayer = Object.assign({}, temp, data);
}
function sessionDataLayer(eventData) {
  let sessionDataLayer = JSON.parse(
    window.sessionStorage.getItem("christDataLayer") || "{}"
  );
  let christDataLayer = [];
  if (sessionDataLayer.content?.length > 0) {
    christDataLayer = sessionDataLayer.content;
    christDataLayer.push(eventData);
  } else {
    christDataLayer.push(eventData);
  }
  const value = JSON.stringify({
    expires: -1,
    content: christDataLayer,
  });
  window.sessionStorage.setItem("christDataLayer", value);
}
// /Tag: /tags//shared/googleTagManager/dataLayerInc/prepareHomepage.tag
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-W6C298Z");

(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "gcm_dataLayer", "GTM-P8TV4X9");